import {
    GENERATE_LINKEDINAD_REQUEST,
    GENERATE_LINKEDINAD_SUCCESS,
    // GENERATE_LINKEDINAD_SAVE,
    GENERATE_LINKEDINAD_FAIL,
    GENERATE_LINKEDINAD_RESET,
    GENERATE_TAGLINE_REQUEST,
    GENERATE_TAGLINE_SUCCESS,
    // GENERATE_TAGLINE_SAVE,
    GENERATE_TAGLINE_FAIL,
    GENERATE_TAGLINE_RESET,
    GENERATE_GOOGLEAD_REQUEST,
    GENERATE_GOOGLEAD_SUCCESS,
    // GENERATE_GOOGLEAD_SAVE,
    GENERATE_GOOGLEAD_FAIL,
    GENERATE_GOOGLEAD_RESET,
    GENERATE_AMAZONDESC_REQUEST,
    GENERATE_AMAZONDESC_SUCCESS,
    // GENERATE_AMAZONDESC_SAVE,
    GENERATE_AMAZONDESC_FAIL,
    GENERATE_AMAZONDESC_RESET,
    // GENERATE_BLOGOUTLINE_SAVE,
    GENERATE_BLOGOUTLINE_REQUEST,
    GENERATE_BLOGOUTLINE_SUCCESS,
    GENERATE_BLOGOUTLINE_FAIL,
    GENERATE_BLOGOUTLINE_RESET,
    //GENERATE_BLOGIDEAS_SAVE,
    GENERATE_BLOGIDEAS_REQUEST,
    GENERATE_BLOGIDEAS_SUCCESS,
    GENERATE_BLOGIDEAS_FAIL,
    GENERATE_BLOGIDEAS_RESET,
    //GENERATE_BLOGQUOTE_SAVE,
    GENERATE_BLOGQUOTE_REQUEST,
    GENERATE_BLOGQUOTE_SUCCESS,
    GENERATE_BLOGQUOTE_FAIL,
    GENERATE_BLOGQUOTE_RESET,
    //GENERATE_BLOGINTRO_SAVE,
    GENERATE_BLOGINTRO_REQUEST,
    GENERATE_BLOGINTRO_SUCCESS,
    GENERATE_BLOGINTRO_FAIL,
    GENERATE_BLOGINTRO_RESET,
    //GENERATE_DISPLAYADS_SAVE,
    GENERATE_DISPLAYADS_REQUEST,
    GENERATE_DISPLAYADS_SUCCESS,
    GENERATE_DISPLAYADS_FAIL,
    GENERATE_DISPLAYADS_RESET,
    //GENERATE_FAQ_SAVE,
    GENERATE_FAQ_REQUEST,
    GENERATE_FAQ_SUCCESS,
    GENERATE_FAQ_FAIL,
    GENERATE_FAQ_RESET,
    //GENERATE_PAINAGITATE_SAVE
    GENERATE_PAINAGITATE_REQUEST,
    GENERATE_PAINAGITATE_SUCCESS,
    GENERATE_PAINAGITATE_FAIL,
    GENERATE_PAINAGITATE_RESET,
    //GENERATE_FACEBOOKAD_SAVE
    GENERATE_FACEBOOKAD_REQUEST,
    GENERATE_FACEBOOKAD_SUCCESS,
    GENERATE_FACEBOOKAD_FAIL,
    GENERATE_FACEBOOKAD_RESET,

} from '../constants/generateConstants';

export const linkedinAdGenerateReducer = (state = { linkedInAddDetails: [] }, action) => {
    switch (action.type) {
        case GENERATE_LINKEDINAD_REQUEST:
            return { loading: true, linkedInAddDetails: [] }
        case GENERATE_LINKEDINAD_SUCCESS:
            return { loading: false, linkedInAddDetails: action.payload.resultData, companyName: action.payload.companyName, companyDesc: action.payload.companyDesc }
        // case GENERATE_LINKEDINAD_SAVE:
        //     return { loading: false, linkedInAddDetails: action.payload.resultData, companyName: action.payload.companyName }
        case GENERATE_LINKEDINAD_FAIL:
            return { loading: false, error: action.payload }
        case GENERATE_LINKEDINAD_RESET:
            return {}
        default:
            return state
    }
}

export const taglineGenerateReducer = (state = { taglineDetails: [] }, action) => {
    switch (action.type) {
        case GENERATE_TAGLINE_REQUEST:
            return { loading: true, taglineDetails: [] }
        case GENERATE_TAGLINE_SUCCESS:
            return { loading: false, taglineDetails: action.payload.resultData, companyName: action.payload.companyName, companyDesc: action.payload.companyDesc }
        case GENERATE_TAGLINE_FAIL:
            return { loading: false, error: action.payload }
        case GENERATE_TAGLINE_RESET:
            return {}
        default:
            return state
    }
}

export const googleAdGenerateReducer = (state = { googleAddDetails: [], googleAddHeadlines: [] }, action) => {
    switch (action.type) {
        case GENERATE_GOOGLEAD_REQUEST:
            return { loading: true, googleAddDetails: [], googleAddHeadlines: [] }
        case GENERATE_GOOGLEAD_SUCCESS:
            return { loading: false, googleAddDetails: action.payload.descriptions, googleAddHeadlines: action.payload.headlines, websiteURL: action.payload.websiteURL, adDesc: action.payload.adDesc }
        case GENERATE_GOOGLEAD_FAIL:
            return { loading: false, error: action.payload }
        case GENERATE_GOOGLEAD_RESET:
            return {}
        default:
            return state
    }
}

export const amazonDescGenerateReducer = (state = { amazonDescDetails: [] }, action) => {
    switch (action.type) {
        case GENERATE_AMAZONDESC_REQUEST:
            return { loading: true, amazonDescDetails: [] }
        case GENERATE_AMAZONDESC_SUCCESS:
            return { loading: false, amazonDescDetails: action.payload }
        case GENERATE_AMAZONDESC_FAIL:
            return { loading: false, error: action.payload }
        case GENERATE_AMAZONDESC_RESET:
            return {}
        default:
            return state
    }
}

export const blogOutlineGenerateReducer = (state = { blogOutlineDetails: [] }, action) => {
    switch (action.type) {
        case GENERATE_BLOGOUTLINE_REQUEST:
            return { loading: true, blogOutlineDetails: [] }
        case GENERATE_BLOGOUTLINE_SUCCESS:
            return { loading: false, blogOutlineDetails: action.payload.resultData, blogTitle: action.payload.blogTitle, blogDesc: action.payload.blogDesc }
        case GENERATE_BLOGOUTLINE_FAIL:
            return { loading: false, error: action.payload }
        case GENERATE_BLOGOUTLINE_RESET:
            return {}
        default:
            return state
    }
}

export const blogIdeasGenerateReducer = (state = { blogIdeasDetails: [] }, action) => {
    switch (action.type) {
        case GENERATE_BLOGIDEAS_REQUEST:
            return { loading: true, blogIdeasDetails: [] }
        case GENERATE_BLOGIDEAS_SUCCESS:
            return { loading: false, blogIdeasDetails: action.payload.resultData,  blogDesc: action.payload.blogDesc }
        case GENERATE_BLOGIDEAS_FAIL:
            return { loading: false, error: action.payload }
        case GENERATE_BLOGIDEAS_RESET:
            return {}
        default:
            return state
    }
}

export const blogQuoteGenerateReducer = (state = { blogQuotesDetails: [] }, action) => {
    switch (action.type) {
        case GENERATE_BLOGQUOTE_REQUEST:
            return { loading: true, blogQuoteDetails: [] }
        case GENERATE_BLOGQUOTE_SUCCESS:
            return { loading: false, blogQuoteDetails: action.payload.resultData, blogTitle: action.payload.blogTitle, blogDesc: action.payload.blogDesc }
        case GENERATE_BLOGQUOTE_FAIL:
            return { loading: false, error: action.payload }
        case GENERATE_BLOGQUOTE_RESET:
            return {}
        default:
            return state
    }
}


export const blogIntroGenerateReducer = (state = { blogIntroDetails: [] }, action) => {
    switch (action.type) {
        case GENERATE_BLOGINTRO_REQUEST:
            return { loading: true, blogIntroDetails: [] }
        case GENERATE_BLOGINTRO_SUCCESS:
            return { loading: false, blogIntroDetails: action.payload.resultData, blogTitle: action.payload.blogTitle, blogDesc: action.payload.blogDesc }
        case GENERATE_BLOGINTRO_FAIL:
            return { loading: false, error: action.payload }
        case GENERATE_BLOGINTRO_RESET:
            return {}
        default:
            return state
    }
}

export const displayAdsGenerateReducer = (state = { displayAdsDetails: [] }, action) => {
    switch (action.type) {
        case GENERATE_DISPLAYADS_REQUEST:
            return { loading: true, displayAdsDetails: [] }
        case GENERATE_DISPLAYADS_SUCCESS:
            return { loading: false, displayAdsDetails: action.payload.resultData, topic: action.payload.topic }
        case GENERATE_DISPLAYADS_FAIL:
            return { loading: false, error: action.payload }
        case GENERATE_DISPLAYADS_RESET:
            return {}
        default:
            return state
    }
}

export const FaqGenerateReducer = (state = { FaqDetails: [] }, action) => {
    switch (action.type) {
        case GENERATE_FAQ_REQUEST:
            return { loading: true, FaqDetails: [] }
        case GENERATE_FAQ_SUCCESS:
            return { loading: false, FaqDetails: action.payload.resultData, topic: action.payload.topic }
        case GENERATE_FAQ_FAIL:
            return { loading: false, error: action.payload }
        case GENERATE_FAQ_RESET:
            return {}
        default:
            return state
    }
}

export const painAgitateGenerateReducer = (state = { painAgitateDetails: [] }, action) => {
    switch (action.type) {
        case GENERATE_PAINAGITATE_REQUEST:
            return { loading: true, painAgitateDetails: [] }
        case GENERATE_PAINAGITATE_SUCCESS:
            return { loading: false, painAgitateDetails: action.payload.resultData, topic: action.payload.topic }
        case GENERATE_PAINAGITATE_FAIL:
            return { loading: false, error: action.payload }
        case GENERATE_PAINAGITATE_RESET:
            return {}
        default:
            return state
    }
}

export const facebookAdGenerateReducer = (state = { facebookAddDetails: [], facebookAddHeadlines: [] }, action) => {
    switch (action.type) {
        case GENERATE_FACEBOOKAD_REQUEST:
            return { loading: true, facebookAddDetails: [], facebookAddSubHeading: [], facebookAddSubText: [] }
        case GENERATE_FACEBOOKAD_SUCCESS:
            return { loading: false, facebookAddDetails: action.payload.descriptions, facebookAddSubHeading: action.payload.subHeading, facebookAddSubText: action.payload.subText, facebookAddwebsiteURL: action.payload.websiteURL, facebookadDesc: action.payload.adDesc }
        case GENERATE_FACEBOOKAD_FAIL:
            return { loading: false, error: action.payload }
        case GENERATE_FACEBOOKAD_RESET:
            return {}
        default:
            return state
    }
}